/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/no-unresolved */
import React from 'react';
// i18n
import { useTranslation } from 'react-i18next';
// ui
import Grid from '@material-ui/core/Grid';
// material ui
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
// icons
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
// utils
import { truthty, falsy } from 'utils/functions';
import SkeletonList from 'commons/components/SkeletonList';
import CustomPagination from 'commons/components/CustomPagination';
import { List } from '@material-ui/core';
import { Header } from 'commons/components/DataTable/Header';

// 1. IMPORTACIÓN DE COMPONENTES Y HOOKS DE AUTOMATIZACIÓN
import Item from './Item';
import ItemAutomation from './ItemAutomation';
import { useAutomation } from 'utils/hooks/useAutomationPermission';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';

function ItemList(props) {
  const { t } = useTranslation();
  const {
    actions,
    classes,
    objects,
    processList,
    toggleEdit,
    toggleDelete,
    handleClick,
    handleClose,
    anchorEl,
    processOnClick,
    loaders,
    pagination,
    filter,
    loadingProcess,
    headerList,
    isMobileDevice,
    suppliersByProcess,
    onOpenReclassifyModal,
  } = props;

  // 2. VALIDACIÓN DE PERMISOS
  const { hasAutomation } = useAutomation();
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: props.role?.name,
  });
  const { canEdit, canDelete, canReprocess } = accessPolicy.processes;

  const anchorElProcess =
    truthty(anchorEl) && processList.find((elem) => elem.id === Number(anchorEl.dataset.id));

  function handleChangeRowsPerPage(e) {
    actions.paginationControls(filter, { ...pagination, rowsPerPage: e.target.value });
  }

  function handleChangePage(e, val) {
    actions.paginationControls(filter, { ...pagination, page: val });
  }

  return (
    <Grid item xs={12}>
      <Card className={classes.root}>
        <CardContent>
          {truthty(processList) ? (
            <Grid container spacing={3} className={classes.container}>
              <Grid item xs={12}>
                {loadingProcess ? (
                  <SkeletonList times={pagination.rowsPerPage} />
                ) : (
                  <>
                    <div className={classes.tableViewport}>
                      <div className={classes.tableCanvas}>
                        <Header headerList={headerList} isMobileDevice={isMobileDevice} />
                        <List>
                          {processList.map((process, index) => {
                            const ItemComponent = hasAutomation ? ItemAutomation : Item;

                            return (
                              <ItemComponent
                                key={index}
                                process={process}
                                classes={classes}
                                objects={objects}
                                openMenuHandler={handleClick}
                                closeMenuHandler={handleClose}
                                toggleEdit={toggleEdit}
                                toggleDelete={toggleDelete}
                                anchorEl={anchorEl}
                                processOnClick={processOnClick}
                                headerList={headerList}
                                isMobileDevice={isMobileDevice}
                                suppliersByProcess={suppliersByProcess}
                              />
                            );
                          })}
                        </List>
                      </div>
                    </div>
                  </>
                )}
              </Grid>
              <CustomPagination
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                count={pagination.count}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleChangePage={handleChangePage}
                loading={loadingProcess}
              />
            </Grid>
          ) : (
            <Grid container item xs={12} alignItems="center" justifyContent="center">
              <Typography variant="h6" component="h2">
                {t('No processes')}
              </Typography>
            </Grid>
          )}
          {truthty(anchorElProcess) &&
            falsy(anchorElProcess.closedAt) &&
            (canEdit || canDelete || (hasAutomation && canReprocess && anchorElProcess?.isReclassifiable)) && (
            <Menu anchorEl={anchorEl} keepMounted open={truthty(anchorEl)} onClose={handleClose}>
              {canEdit && (
                <MenuItem onClick={toggleEdit}>
                  <ListItemIcon>
                    <EditIcon />
                  </ListItemIcon>
                  {t('Edit')}
                </MenuItem>
              )}
              {canDelete && (
                <MenuItem onClick={toggleDelete}>
                  <ListItemIcon>
                    <DeleteIcon />
                  </ListItemIcon>
                  {t('Delete')}
                </MenuItem>
              )}
              {hasAutomation && canReprocess && anchorElProcess?.isReclassifiable && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    onOpenReclassifyModal(anchorElProcess);
                  }}>
                  <ListItemIcon>
                    <SyncProblemIcon />
                  </ListItemIcon>
                  {t('process.reclassification.menu')}
                </MenuItem>
              )}
            </Menu>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default ItemList;
